import { createAppSelector, pageSelectors, selectCurrentSectionId } from "./base";

export const selectSectionScorePages = createAppSelector(
  [pageSelectors.selectAll, selectCurrentSectionId, (state, sectionId: string | null) => sectionId],
  (pages, currentSectionId, sectionId) =>
    pages.filter(
      (page) =>
        page.section_id === (sectionId ?? currentSectionId) &&
        page.max_points > 0 &&
        page.released_at &&
        page.assessments_published_at,
    ),
);

export const selectSectionScorePageCount = createAppSelector(
  [selectSectionScorePages],
  (pages) => pages.length,
);
